class ThemeSlider extends HTMLElement {
  labels = []; inputs; values; min; max; step; decimals; container; initialized = false;
  
  connectedCallback() {
    setTimeout(() => {
      this.init();
    }, 0);
  }

  init = () => {
    if(this.dataset.labels !== undefined){
      const labels = this.dataset.labels.split(',');
      labels.forEach(label => {
        const labelElement = document.querySelector(label);
        if(labelElement !== null){
          this.labels.push(labelElement);
        }
      });
    }
    this.decimals = this.dataset.decimals !== undefined ? parseInt(this.dataset.decimals) : 0;

    this.inputs = this.querySelectorAll('input');
    const values = this.dataset.values.split(',');
    this.values = values.map(value => parseInt(value));

    this.min = parseInt(this.dataset.min);
    this.max = parseInt(this.dataset.max);
    this.step = this.dataset.step == undefined ? 1 : parseInt(this.dataset.step);
    
    this.container = this.querySelector('[data-container]') || this;
    noUiSlider.create(this.container, {
      start: this.values,
      connect: true,
      range: {
        'min': this.min,
        'max': this.max
      },
      step: this.step
    });

    this.container.noUiSlider.on('update', (values) => {
      this.setInputs(values);
    }); 

    this.container.noUiSlider.on('change', (values) => {
      this.setInputs(values);
      this.triggerChange();
    });

    this.inputs.forEach((input, index) => {
      input.addEventListener('input', (e) => {
        this.checkValue(input, e);
      });
    });
  }

  checkValue = (input, e) => {
    const v = parseInt(input.value);
    if(v >= this.min && v <= this.max){
      this.container.noUiSlider.set(Array.from(this.inputs).map(input => parseInt(input.value)));
    } else {
      e.preventDefault();
    }
  }

  triggerChange = () => {
    if(this.initialized){
      console.log('trigger change');
      this.inputs.forEach((input, index) => {
        input.dispatchEvent(new Event("change", { bubbles: true }));
      });
    }
  }

  setInputs = (values) => {
    if(this.initialized){
      this.values = values.map(value => parseInt(value));
      this.inputs.forEach((input, index) => {
        input.value = this.values[index];
      });
    }
    this.addRangeInputs();
    this.initialized = true;
  }

  addRangeInputs = () => {
    const rangeValues = this.dataset.rangeValues.split(',').map(value => parseInt(value)).filter(value => value >= this.values[0] && value <= this.values[this.values.length - 1]);
    this.querySelectorAll('input[type="hidden"]').forEach((input, index) => {
      input.remove();
    });
    if(rangeValues.length > 0 && (rangeValues[0] != this.min || rangeValues[rangeValues.length - 1] != this.max)){
      rangeValues.forEach(value => {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = this.dataset.name;
        input.value = value;
        this.appendChild(input);
      });
    }
  }

  setValues = (values) => {
    this.values = values.map(value => parseInt(value));
    this.setLabels();
  }

  setLabels = () => {
    if(this.labels.length > 0){
      this.labels.forEach((label, index) => {
        label.innerHTML = this.format(this.values[index]);
      });
    }
  }

  format = (value) => {
    const format = this.dataset.format || '{label}';
    return format.replaceAll('{label}', value);
  }

  getInputs = () => {
    return this.inputs;
  }
  
}
if (!window.customElements.get("theme-slider")) {
  window.customElements.define("theme-slider", ThemeSlider);
}